export default {
  methods: {
    adjustScroll(scrollBefore, heightBefore) {
      const scrollEl = document.getElementById('content__wrapper');
      const listEl = document.getElementById('listView');
      const diff = listEl.offsetHeight - heightBefore;
      if (Number.isFinite(diff) && diff !== 0) {
        scrollEl.scrollTop = Math.max(0, scrollBefore + diff);
      }
    },
    scrollList(prop) {
      if (prop.endPage && !this.isLoading && this.isLastDownloaded) {
        this.curPage += 1;
        this.getPage();
      }
      if (prop.startPage && !this.isLoading && this.firstPage > 1) {
        this.getPrevPage();
      }
    },
    checkScrollBoundaries() {
      const el = document.getElementById('content__wrapper');
      if (el.scrollTop === 0 && this.firstPage > 1 && !this.isLoading) {
        this.getPrevPage();
        return;
      }
      this.fillViewport();
    },
    // Подгрузка идёт по событию прокрутки. Если загруженные страницы целиком
    // помещаются в экран (большой монитор, короткая страница), прокручивать
    // нечего и следующая страница не придёт никогда. Поэтому догружаем, пока
    // конец списка виден без прокрутки — тем же признаком, что и endPage
    // в baseListView. getPage после загрузки снова зовёт checkScrollBoundaries.
    fillViewport() {
      if (this.isLoading || !this.isLastDownloaded) return;
      if (this.countPage === null || this.curPage >= this.countPage) return;

      const el = document.getElementById('content__wrapper');
      const listEl = document.getElementById('listView');
      if (!el || !listEl) return;

      if (el.scrollTop + el.offsetHeight > listEl.offsetHeight) {
        this.curPage += 1;
        this.getPage();
      }
    },
    repeatGetPage() {
      this.getPage();
    },
  },
};
